import { KeyValue } from "@/main/models/common";
import { ManufacturerRequest } from "@/main/models/request";
import { ManufacturerTypes, ManufacturerActionTypes } from "./manufacturerTypes";

export function getManufacturers(
	request: ManufacturerRequest,
	keyReducer: string = "default",
): ManufacturerActionTypes {
	return {
		type: ManufacturerTypes.GET_MANUFACTURERS,
		payload: { request, keyReducer },
	};
}

export function saveManufacturers(
	data: KeyValue[] | null,
	isError: boolean,
	errorMessages: string[] | null,
	keyReducer: string = "default",
): ManufacturerActionTypes {
	return {
		type: ManufacturerTypes.SAVE_MANUFACTURERS,
		payload: { data, isError, errorMessages, keyReducer },
	};
}

export function resetReducerManufacturers(keyReducer: string = "default"): ManufacturerActionTypes {
	return {
		type: ManufacturerTypes.RESET_REDUCER_MANUFACTURERS,
		payload: { keyReducer },
	};
}
